var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "topnav-product-line-container",
        { "four-items": _vm.itemsArray.length === 4 }
      ]
    },
    _vm._l(_vm.itemsArray, function(item) {
      return _c(
        "a",
        {
          key: item.image,
          staticClass: "product-line",
          attrs: { href: item.link }
        },
        [
          _c("img", {
            staticClass: "product-image",
            attrs: {
              src: item.image,
              alt: item.alt,
              "aspect-ratio": "1",
              contain: ""
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "product-text" }, [
            _c("h6", { staticClass: "product-title" }, [
              _c("span", { domProps: { innerHTML: _vm._s(item.text) } })
            ]),
            _vm._v(" "),
            _c("p", {
              staticClass: "product-description",
              domProps: { innerHTML: _vm._s(item.desc) }
            })
          ])
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }